import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/bonuses';
import { SectionCTA } from '../SectionCTA';
export function Bonuses() {
  return <section className="w-full bg-cream px-0 py-16 sm:px-6 sm:py-20" data-id="element-120" data-mp="1ckwmoevoutp3">
      <div className="mx-auto max-w-5xl" data-id="element-121" data-mp="1cj3fmyh5y7gk">
        <div className="px-4 sm:px-0" data-id="element-122" data-mp="18k4abcris8ol">
          <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-flag" data-id="element-123" data-mp="18lfgfj8ftsiv">
            🎁 Only with today’s offer
          </p>
          <h2 className="mt-3 text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-124" data-mp="20a8ubabdatpa">
            Get 5 professional bonuses free
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-125" data-mp="1wb0064cf0tt7">
            Five additional resources included at no extra cost when you get the DVO Clinical
            Workflow Builder™ today.
          </p>
        </div>

        <div className="mt-10 space-y-6 sm:space-y-8" data-id="element-126" data-mp="fu467g4uezms">
          {bonuses.map(bonus => <article key={bonus.tag} className="overflow-hidden border-y border-navy-100 bg-white shadow-soft sm:rounded-3xl sm:border" data-id="element-127" data-mp="1euyfe937slef">
              <img src={bonus.image} alt={bonus.alt} className="w-full bg-white object-contain" loading="lazy" data-id="element-128" data-mp="15trvdq1cwsgf" />

              <div className="px-4 pb-6 pt-2 sm:px-7 sm:pb-7" data-id="element-129" data-mp="w2nhyurbxfnp">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-flag/10 px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-flag" data-id="element-130" data-mp="w12oz9kny4ry">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-131" data-mp="n3sdbn3xodmi" />
                  {bonus.tag}
                </span>

                <h3 className="mt-3 text-xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-2xl" data-id="element-132" data-mp="r1zu2hyedexp">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-display text-[16px] italic text-navy-600" data-id="element-133" data-mp="i2utl639zbiw">
                  {bonus.subtitle}
                </p>

                <p className="mt-3.5 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-134" data-mp="2f1v5355ykokb">
                  {bonus.description}
                </p>

                {bonus.includes && <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-135" data-mp="2ay5keqsemr4k">
                    {bonus.includes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-136" data-mp="32rfmvkqdlfs0">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-go" aria-hidden="true" data-id="element-137" data-mp="32pbmhcroqywh" />
                        <span className="text-[14px] leading-snug text-ink" data-id="element-138" data-mp="2tp6fh3qem2iu">{item}</span>
                      </li>)}
                  </ul>}

                <p className="mt-5 inline-block rounded-xl bg-go-light px-4 py-2 text-[12.5px] font-extrabold uppercase tracking-[0.08em] text-go-dark" data-id="element-139" data-mp="1ibuhh9hbse4l">
                  Value: {bonus.value} — free today
                </p>
              </div>
            </article>)}
        </div>

        <div className="px-4 sm:px-0" data-id="element-140" data-mp="186umt89hsoqz">
          <SectionCTA transformation="$197 in bonuses, included at no extra cost today." label="Get all 5 bonuses free" subline="Included with today’s $27 offer" data-id="element-141" data-mp="187xcxdyzqn5u" />
        </div>
      </div>
    </section>;
}